import { useBreakpoint } from '@buffer-mono/popcorn'

export function useIsMobileBreakpoint(): boolean {
  const breakpoint = useBreakpoint()
  return ['initial', 'xs', 'sm'].includes(breakpoint)
}
